package org.gstechnovos.jexonplastech.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.Delay
import kotlinx.coroutines.delay
import org.w3c.dom.events.EventListener

@Composable
fun ObserveViewportEntered(
    sectionId: String,
    distanceFromTop: Double,
    onViewportEntered: () -> Unit,
) {
    var viewportEntered by remember { mutableStateOf(false) }

    DisposableEffect(key1 = sectionId) {
        // 1. Extract the logic into a standard Kotlin function
        fun checkVisibility() {
            val element = document.getElementById(sectionId)
            if (element != null) {
                val top = element.getBoundingClientRect().top
                if (top < distanceFromTop) {
                    viewportEntered = true
                }
            }
        }

        // 2. Create the EventListener, which simply calls our function
        val listener = EventListener { checkVisibility() }

        // 3. Add the listener to the window
        window.addEventListener("scroll", listener)
        window.addEventListener("resize", listener)

        // 4. Call the function DIRECTLY for the initial check (No dummy Event needed!)
        window.setTimeout({
            checkVisibility()
        }, 100)

        onDispose {
            window.removeEventListener("scroll", listener)
            window.removeEventListener("resize", listener)
        }
    }

    LaunchedEffect(viewportEntered) {
        if (viewportEntered) {
            onViewportEntered()
        }
    }
}

suspend fun AnimatePercentage(percentage: Int, delay: Long = 10L, onUpdate: (Int) -> Unit) {
    (0..percentage).forEach {
        delay(delay)
        onUpdate(it)
    }
}

